import * as qs from 'qs';
import { axios } from '~/libs/axios';
import {
  Chain,
  type CoinTrendingOptions,
  SortBy,
  SortType,
  type TCoinTrending,
} from '~/types';

const getCoinTrending = async (
  options?: CoinTrendingOptions,
): Promise<TCoinTrending> => {
  const queryParams = qs.stringify({
    chain: options?.chain || Chain.Solana,
    limit: options?.limit || 2,
    offset: options?.offset || 0,
    sort_type: options?.sort_type || SortType.Desc,
    sort_by: options?.sort_by || SortBy.Liquidity,
  });
  const { data } = await axios.get<TCoinTrending>(
    '/coin_snippet/trending?' + queryParams,
  );
  return data;
};

export const coinAPI = {
  getCoinTrending,
};
